// Handle Osano slide in drawer

document.querySelectorAll('.osano-trigger').forEach(function (element) {
  element.onclick = function (event) {
    event.preventDefault();
    Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
  };
});

// Osano Shopify API interaction

window.Shopify.loadFeatures(
  [
    {
      name: 'consent-tracking-api',
      version: '0.1',
    },
  ],
  function (error) {
    if (!error) {
      try {
        window.Osano.cm.ready('shopify');
      } catch (error) {
        console.error(
          'Osano must be loaded before initializing th Shopify API.',
        );
      }
    }
  },
);
